import Swiper from "swiper";
import {Navigation, Pagination, Scrollbar, FreeMode} from "swiper/modules";

export default function (rootEl) {

    const swiperEl = rootEl.querySelector('.swiper');
    const slideEls = rootEl.querySelectorAll('.swiper-slide');
    let swiperConfig = rootEl.dataset.swiperConfig;

    function notifyError() {
        rootEl.style.outline = '1px solid red';
    }

    if (!swiperConfig) {
        console.error(`SWIPER: Swiper instance doesn't have config. Root: ${rootEl.className}`);
        notifyError();
        return;
    }

    try {
        swiperConfig = JSON.parse(swiperConfig);
    } catch (e) {
        notifyError();
        console.error(`SWIPER: Error when parsing data-swiper-config`, e);
        return;
    }

    if (slideEls.length < 1) {
        console.error('SWIPER: Swiper instance has only 1 slide so we skip creating a swiper instance.');
        return;
    }

    // Custom pagination for VehicleColoursModule
    if (rootEl.classList.contains('js-general-swiper') && rootEl.querySelector('.js-vehicle-colours-swiper-pagination')) {
        const colourLabels = Array.from(slideEls).map(slide => {
            return slide.dataset.colourLabel;
        });
        const colours = Array.from(slideEls).map(slide => {
            return slide.dataset.colour;
        });
        swiperConfig.pagination = {
            ...swiperConfig.pagination,
            renderBullet: function (index, className) {
                return `<button class="${className} c-vehicle-colour" style="background-color:${colours[index]}" title="${colourLabels[index]}"></button>`;
            }
        };
    }

    window.swiper = new Swiper(swiperEl, {
        modules: [Navigation, Pagination, Scrollbar, FreeMode], ...swiperConfig
    });
};
